// src/components/productCard.js - NOVO DESIGN E LÓGICA DE BOTÃO

import React from 'react';
import { ShoppingCart, Check } from 'lucide-react'; // Adicionamos 'Check' para o feedback

export default function ProductCard({ image, title, price, quantity, description, addToCart }) {
  const product = { image, title, price, quantity, description };
  
  // Exemplo de como você pode gerenciar um feedback visual de "Adicionado!"
  // Para algo mais robusto, você pode usar um estado global ou um contexto.
  const [added, setAdded] = React.useState(false);

  const handleAddToCart = () => {
    addToCart(product);
    setAdded(true);
    // Opcional: Remover o feedback após alguns segundos
    setTimeout(() => setAdded(false), 2000); 
  };

  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col h-full" >
      {/* Imagem do Produto */}
      <div className="relative w-full h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-300" 
        />
        {/* Aqui você pode adicionar tags como "MAIS VENDIDO" ou "OFERTA ESPECIAL" */}
        {/* Por exemplo:
        <span className="absolute top-2 left-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full">
          MAIS VENDIDO
        </span>
        */}
      </div>

      {/* Conteúdo do Card */}
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-gray-800 mb-2">{title}</h3>
        
        {/* Descrição em lista de pontos */}
        <ul className="text-sm text-gray-600 space-y-1 mb-4 flex-grow">
          {description.split('\n').map((line, index) => (
            <li key={index} className="flex items-center">
              <span className="w-1.5 h-1.5 bg-green-500 rounded-full mr-2"></span>
              {line}
            </li>
          ))}
        </ul>
        
        {/* Preço e Quantidade Original (opcional) */}
        <div className="flex justify-between items-center text-sm mb-4">
          <span className="font-semibold text-gray-700">Quantidade: {product.quantity} und</span>
          <span className="text-xl font-bold text-green-700">R$ {price}</span>
        </div>

        {/* Botão de Adicionar ao Carrinho */}
        <button 
          onClick={handleAddToCart}
          className={`w-full flex items-center justify-center gap-2 py-3 rounded-lg text-white font-semibold transition-all duration-300 
            ${added ? 'bg-green-500 hover:bg-green-600' : 'bg-orange-500 hover:bg-orange-600'}`}
        >
          {added ? (
            <>
              Adicionado! <Check className="w-5 h-5" />
            </>
          ) : (
            <>
              Adicionar ao Carrinho <ShoppingCart className="w-5 h-5" />
            </>
          )}
        </button>
      </div>
    </div>
  );
}